(function () {
  'use strict';
  if (window.SanoDeliveryClock) return;
  var formatterCache = {};
  function parts(time, zone) {
    var formatter = formatterCache[zone] || (formatterCache[zone] = new Intl.DateTimeFormat('en-GB', {
      timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }));
    var result = {};
    formatter.formatToParts(new Date(time)).forEach(function (part) { if (part.type !== 'literal') result[part.type] = Number(part.value); });
    return result;
  }
  function dateKey(p) { return p.year + '-' + String(p.month).padStart(2, '0') + '-' + String(p.day).padStart(2, '0'); }
  function validTime(value) { return typeof value === 'string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(value); }
  function configure(raw) {
    if (!raw || raw.confirmed !== true || !validTime(raw.cutoff)) return null;
    var zone = raw.timezone || 'Europe/Amsterdam';
    try { parts(Date.now(), zone); } catch (_) { return null; }
    var days = String(raw.weekdays || '').split(',').map(function (day) { return Number(day.trim()); });
    if (!days.length || days.some(function (day) { return !Number.isInteger(day) || day < 1 || day > 7; })) return null;
    var exceptions = {}, invalid = false;
    String(raw.exceptions || '').split(/\r?\n/).forEach(function (line) {
      if (!line.trim()) return;
      var match = line.trim().match(/^(\d{4}-\d{2}-\d{2})\s*=\s*(closed|\d{2}:\d{2})$/);
      if (!match || (match[2] !== 'closed' && !validTime(match[2]))) { invalid = true; return; }
      var date = new Date(match[1] + 'T12:00:00Z');
      if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== match[1] || Object.prototype.hasOwnProperty.call(exceptions, match[1])) { invalid = true; return; }
      exceptions[match[1]] = match[2];
    });
    var deliveryExceptions = {};
    String(raw.deliveryExceptions || '').split(/\r?\n/).forEach(function (line) {
      if (!line.trim()) return;
      var match = line.trim().match(/^(\d{4}-\d{2}-\d{2})\s*=\s*(closed|open)$/);
      if (!match) { invalid = true; return; }
      var date = new Date(match[1] + 'T12:00:00Z');
      if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== match[1] || Object.prototype.hasOwnProperty.call(deliveryExceptions, match[1])) { invalid = true; return; }
      deliveryExceptions[match[1]] = match[2];
    });
    return invalid ? null : { cutoff: raw.cutoff, timezone: zone, weekdays: days, exceptions: exceptions, deliveryExceptions: deliveryExceptions, nlHolidays: raw.nlHolidays !== false };
  }
  var holidayCache = {};
  function holidays(year) {
    if (holidayCache[year]) return holidayCache[year];
    // Gregorian Easter (Meeus/Jones/Butcher), plus Dutch official fixed holidays.
    var a = year % 19, b = Math.floor(year / 100), c = year % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31), day = (h + l - 7 * m + 114) % 31 + 1;
    var result = {}, easter = Date.UTC(year, month - 1, day);
    [-2, 0, 1, 39, 49, 50].forEach(function (offset) { result[new Date(easter + offset * 86400000).toISOString().slice(0, 10)] = true; });
    ['01-01', '05-05', '12-25', '12-26'].forEach(function (date) { result[year + '-' + date] = true; });
    result[year + '-04-' + (new Date(Date.UTC(year, 3, 27)).getUTCDay() === 0 ? '26' : '27')] = true;
    holidayCache[year] = result;
    return result;
  }
  function holiday(date, config) { return config.nlHolidays && Boolean(holidays(date.year)[dateKey(date)]); }
  function dateAt(time) { var d = new Date(time); return { year: d.getUTCFullYear(), month: d.getUTCMonth() + 1, day: d.getUTCDate() }; }
  function localDeadline(date, clock, zone) {
    var time = clock.split(':').map(Number), desired = Date.UTC(date.year, date.month - 1, date.day, time[0], time[1]);
    // Obtain offsets either side of the date. Verify candidates: spring-forward
    // nonexistent times are skipped; autumn repeated times use the earlier instant.
    var candidates = [];
    [-36, 0, 36].forEach(function (hours) {
      var sample = desired + hours * 3600000, p = parts(sample, zone);
      var offset = Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - sample;
      var candidate = desired - offset, actual = parts(candidate, zone);
      if (dateKey(actual) === dateKey(date) && actual.hour === time[0] && actual.minute === time[1]) candidates.push(candidate);
    });
    return candidates.length ? Math.min.apply(null, candidates) : null;
  }
  function nextDeadline(now, config) {
    var zone = config ? config.timezone : 'Europe/Amsterdam';
    var today = parts(now, zone);
    var tomorrow = dateAt(Date.UTC(today.year, today.month - 1, today.day + 1));
    return localDeadline(tomorrow, '00:00', zone);
  }
  function schedule(now, config) {
    var zone = config ? config.timezone : 'Europe/Amsterdam';
    var today = parts(now, zone);
    var tomorrow = dateAt(Date.UTC(today.year, today.month - 1, today.day + 1));
    return { deadline: nextDeadline(now, config), orderDate: dateKey(today), today: dateKey(today), deliveryDate: dateKey(tomorrow), uncertain: false };
  }
  var deliveryDateFormatter = new Intl.DateTimeFormat('nl-NL', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' });
  function dutchDate(date) { return deliveryDateFormatter.format(new Date(date + 'T12:00:00Z')); }
  var config = null, timer = null;
  function refreshConfig() {
    var node = document.getElementById('SanoDeliveryConfig');
    try { config = configure(node ? JSON.parse(node.textContent) : null); } catch (_) { config = null; }
    if (timer) { window.clearInterval(timer); timer = null; }
    refresh();
    if (!document.hidden) timer = window.setInterval(refresh, 1000);
  }
  var digitViews = new WeakMap();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function renderDigits(copy, seconds) {
    if (!copy) return;
    var values = [String(Math.floor(seconds / 3600)).padStart(2, '0'), String(Math.floor(seconds / 60) % 60).padStart(2, '0'), String(seconds % 60).padStart(2, '0')];
    var view = digitViews.get(copy);
    if (!view) {
      var wrapper = document.createElement('span');wrapper.className = 'sano-clock-digits';wrapper.setAttribute('aria-hidden', 'true');
      view = [];
      ['uur', 'min', 'sec'].forEach(function (label, unit) {
        var group = document.createElement('span');group.className = 'sano-clock-unit';group.dataset.clockUnit = label;
        var digits = document.createElement('span');digits.className = 'sano-clock-number';group.appendChild(digits);
        var caption = document.createElement('span');caption.className = 'sano-clock-label';caption.textContent = ' ' + label;group.appendChild(caption);wrapper.appendChild(group);
        view.push({node:digits, slots:[]});
      });
      copy.replaceChildren(wrapper);digitViews.set(copy, view);copy.setAttribute('role','img');
    }
    copy.setAttribute('aria-label', values[0] + ' uur ' + values[1] + ' minuten ' + values[2] + ' seconden');
    values.forEach(function (value, unit) {
      var group = view[unit];
      while (group.slots.length < value.length) {
        var slot=document.createElement('span');slot.className='sano-clock-digit';
        var old=document.createElement('span'), current=document.createElement('span');old.className='sano-clock-digit__old';current.className='sano-clock-digit__current';slot.append(old,current);group.node.appendChild(slot);group.slots.push({node:slot,old:old,current:current,value:null});
      }
      group.slots.forEach(function (digit,index) {
        digit.node.hidden=index>=value.length;if(digit.node.hidden)return;
        var next=value[index];if(digit.value===next)return;
        var previous=digit.value;digit.value=next;
        [digit.node,digit.old,digit.current].forEach(function(el){el.getAnimations().forEach(function(a){a.cancel();});});
        digit.old.textContent=previous===null?next:previous;digit.current.textContent=next;
        if(previous===null||reducedMotion.matches||!digit.node.animate)return;
        var timing={duration:unit===2?200:260,easing:'cubic-bezier(.2,.65,.3,1)'};
        digit.old.animate([{transform:'translateY(0)',opacity:1},{transform:'translateY(-100%)',opacity:0}],timing);
        digit.current.animate([{transform:'translateY(100%)',opacity:0},{transform:'translateY(0)',opacity:1}],timing);
        digit.node.animate([{backgroundColor:'#da26332b'},{backgroundColor:'transparent'}],{duration:320});
      });
    });
  }
  var clockViews = new WeakMap(), cachedSchedule = null;
  function refresh() {
    var clocks = document.querySelectorAll('[data-sano-delivery-clock]');
    if (!clocks.length) return;
    var now = Date.now(), zone = config ? config.timezone : 'Europe/Amsterdam', day = dateKey(parts(now, zone));
    // Midnight and configuration changes invalidate the schedule; digits still use wall time.
    if (!cachedSchedule || cachedSchedule.config !== config || cachedSchedule.day !== day) cachedSchedule = { config:config, day:day, value:schedule(now, config) };
    var current = cachedSchedule.value;
    clocks.forEach(function (node) {
      var allowed = node.dataset.sanoDeliveryEligible === 'true';
      node.hidden = !allowed || !current;
      if (node.hidden) return;
      var seconds = Math.max(0, Math.ceil((current.deadline - now) / 1000));
      var view = clockViews.get(node);
      if (!view) { view = {copy:node.querySelector('[data-sano-delivery-timer-copy]'),prefix:node.querySelector('[data-sano-delivery-prefix]'),promise:node.querySelector('[data-sano-delivery-promise]'),detail:node.querySelector('[data-sano-delivery-detail]'),schedule:null};clockViews.set(node,view); }
      var copy = view.copy;
      renderDigits(copy, seconds);
      if (view.schedule === current) return;
      view.schedule = current;
      var prefix = view.prefix, promise = view.promise, detail = view.detail;
      var normal = current.today === current.orderDate && !current.uncertain;
      prefix.textContent = normal ? 'Bestel binnen ' : 'Volgende besteldeadline over ';
      promise.textContent = normal ? ' om het morgen te ontvangen' : '';
      detail.textContent = current.uncertain
        ? 'Rond feestdagen of een aangepaste bezorgdag bevestigen we je bezorgdatum apart.'
        : (current.deliveryDate ? 'Verwachte bezorging: ' + dutchDate(current.deliveryDate) + '.' : 'We bevestigen je bezorgdatum apart.');
      detail.hidden = normal;
      node.dataset.deadline = new Date(current.deadline).toISOString();
      node.dataset.deliveryDate = current.deliveryDate || '';
    });
  }
  window.SanoDeliveryClock = { configure: configure, nextDeadline: nextDeadline, schedule: schedule, holidays: holidays, refresh: refresh, reload: refreshConfig };
  document.addEventListener('shopify:section:load', refreshConfig);
  document.addEventListener('visibilitychange', function(){
    if(timer!==null){window.clearInterval(timer);timer=null;}
    if(!document.hidden){refresh();timer=window.setInterval(refresh,1000);}
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshConfig, { once: true });
  else refreshConfig();
})();
